import React, { useEffect, useState } from 'react'
import ThemeMaker from "../../components/thememaker";
import axios from 'axios';
import { NodebaseUrlDefiner, baseUrlDefiner } from "../../utils/config"
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";

export default function Raiseticket() {
    let params = useParams();
    const { id } = params;
    const rawData = {
        "provider_id": "",
        "transaction_id": "",
        "domain": "",
        "bap_id": "",
        "bap_uri": "",
        "status": "OPEN",    //OPEN
        "level": "",     //ISSUE
        "descriptor_code": "",
        "image": ""
    }

    const rawErrorData = {
        name: false,
        email: false,
        company_name: false,
        contact_no: false,
        // provider_id: false,
        gst_no: false,
        pan_no: false,
        pan_name: false,
        pan_image: false,
        address_proof: false,
        address_proof_image: false,
        commission: false,
        // seller_commision: false,
    }

    const [sellerData, setSellerData] = useState(rawData);
    const [sellerDataError, setSellerDataError] = useState(rawErrorData);
    const [sellerList, setSellerList] = useState([]);
    const [resoutionObject, setresolutionObject] = useState({
        "issue_id": id ? id : "",
        "actions_code": ""
    })
    useEffect(() => {
        // getSellerList();
        if (id) {
            getDetailsById()
        }
    }, [])

    async function getDetailsById() {
        try {
            let apiEndpoint = NodebaseUrlDefiner();
            console.log("sellerData---->", sellerData)
            const { data } = await axios({
                method: "GET",
                url: `${apiEndpoint}/igm/reversegetById/${id}`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                // data: { ...sellerData }
            })



            setSellerData({ ...data?.data[0], provider_id: data?.data[0]?.ref_provider_id, image: data?.data[0]?.descriptor?.images[0]?.url })

            console.log(data)
            // if (data?.data?.message?.ack?.status === "ACK") {
            //     toast.success("Ticket generated succesfully!")
            // } else {
            //     toast.error("Error in creating issue.")
            // }
        } catch (err) {
            console.log("Err--->", err)
        }
    }


    const inputHandler = (e) => {
        setSellerData({ ...sellerData, [e.target.name]: e.target.value });
    }
    const errorHandler = (e) => {
        if (e.target.value) {
            setSellerDataError({ ...sellerDataError, [e.target.name]: "valid" });
        } else {
            setSellerDataError({ ...sellerDataError, [e.target.name]: true });
        }
    }

    const getSellerList = async () => {
        let apiEndpoint = baseUrlDefiner();
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }


    async function createTicketHandler() {
        try {
            let apiEndpoint = NodebaseUrlDefiner();
            console.log("sellerData---->", sellerData)
            const { data } = await axios({
                method: "POST",
                url: `${apiEndpoint}/igm/issue`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: { ...sellerData }
            })

            console.log(data)
            if (data?.data?.message?.ack?.status === "ACK") {
                toast.success("Ticket generated succesfully!")
            } else {
                toast.error("Error in creating issue.")
            }
        } catch (err) {
            console.log("Err--->", err)
        }
    }

    const ImageHandler = async (e) => {
        const files = e.target.files;
        const apiEndpoint = NodebaseUrlDefiner();

        if (!files || files.length === 0) {
            alert("Please select file(s) first!");
            return;
        }

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]); // Use the same key 'files'
        }

        try {
            const { data } = await axios.post(
                `${apiEndpoint}/digidukaan/snp/upload`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                        // Let browser set Content-Type
                    }
                }
            );

            if (data?.success) {
                toast.success(data.message || "Upload successful!");
                console.log("Uploaded URLs:", data.urls);
                return data.urls;

            } else {
                toast.error("Upload failed!");
            }

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed!");
        }
    }



    const setImage = async (e) => {
        const image = await ImageHandler(e);
        console.log("Image----", image);
        if (image) {
            setSellerData({ ...sellerData, [e.target.name]: image[0] });
        }

    }

    async function submitActionHandler() {
        let payload;
        if (resoutionObject?.actions_code === "RESOLUTION_ACCEPTED" && sellerData?.level === "ISSUE") {
            payload = {
                ...resoutionObject, bap_uri: sellerData?.bap_uri, level: "ISSUE"
            }
        }

        if (resoutionObject?.actions_code === "ESCALATED" && sellerData?.level === "GRIEVANCE") {
            payload = {
                "bap_uri": sellerData?.bap_uri,
                "level": "GRIEVANCE",
                "issue_id": resoutionObject?.issue_id,
                "status": "OPEN",
                "actions_code": "ESCALATED"

            }
        }
        if (resoutionObject?.actions_code === "RESOLUTION_ACCEPTED" && sellerData?.level === "GRIEVANCE") {
            payload = {
                "bap_uri": sellerData?.bap_uri,
                "issue_id": resoutionObject?.issue_id,
                "level": "GRIEVANCE",
                "actions_code": "RESOLUTION_ACCEPTED"

            }
        }
        if (resoutionObject?.actions_code === "CLOSED" && sellerData?.level === "GRIEVANCE") {
            payload = {
                "bap_uri": sellerData?.bap_uri,
                "issue_id": resoutionObject?.issue_id,
                "level": "GRIEVANCE",
                "actions_code": "RESOLUTION_ACCEPTED"

            }
        }

        try {
            let apiEndpoint = NodebaseUrlDefiner();

            const { data } = await axios({
                method: "POST",
                url: `${apiEndpoint}/igm/issue`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: { ...payload }
            })

            console.log(data)

        } catch (err) {
            console.log("Err--->", err)
        }
    }

    console.log("sellerDatta---->", sellerData)



    return (
        <>
            <ThemeMaker>

                <div className="row m-0 w-100 mt-1">
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h6 className="m-0 d-flex justify-content-between font-weight-bold text-bg-gradient-dark">
                                    <span>
                                        Raise an Issue
                                    </span>

                                    <Link to="/issueslists" > <button className='btn btn-primary btn-sm'>Issue List</button></Link>
                                </h6>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel' >
                                                Provider
                                            </label>


                                            <select name="provider_id" value={sellerData?.provider_id} id="" className={`form-control`} onChange={(e) => inputHandler(e)}>
                                                <option value="" disabled selected>Select Seller</option>
                                                {sellerList.map((item) => (
                                                    <option value={item.provider_id}>{item?.company_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Transaction Id

                                            </label>
                                            <input type="text" className="form-control" name="transaction_id" placeholder="Enter transaction id"
                                                value={sellerData.transaction_id}
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel' >Domain   </label>
                                            <input type="text" name="domain" className="form-control" placeholder="Enter domain"
                                                value={sellerData.domain}
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Bap Id

                                            </label>
                                            <input type="text" name="bap_id" className="form-control" placeholder='Enter Bap id'
                                                value={sellerData.bap_id}
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Bap URI

                                            </label>
                                            <input type="text" className="form-control" name="bap_uri" placeholder="Enter Bap uri"
                                                value={sellerData.bap_uri}
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Level


                                            </label>
                                            <select name="level" id="" className="form-control"
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}
                                                value={sellerData?.level}
                                            >
                                                <option value="">Select Level</option>
                                                <option value="ISSUE">Issue</option>
                                                <option value="GRIEVANCE">Grievance</option>

                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Descriptor Code


                                            </label>
                                            <select name="descriptor_code" id="" className="form-control"
                                                onChange={(e) => inputHandler(e)}
                                                onBlur={(e) => errorHandler(e)}
                                                value={sellerData?.descriptor_code}
                                            >
                                                <option value="">Select </option>
                                                <option value="VIS001">Seller not visible</option>

                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className='genericlabel'>Image     </label>
                                            {sellerData?.image && <a href={sellerData?.image} target='_blank' className='ms-2'>View Image</a>}
                                            <input type="file" name="image" className="form-control"
                                                onChange={(e) => setImage(e)}
                                                onBlur={(e) => errorHandler(e)}

                                            />
                                        </div>
                                    </div>

                                    {id && <p className='genericlabel col-md-12'> Current Status: {sellerData?.actions_code} </p>}

                                    {
                                        (id && sellerData?.resolutions?.length > 0) && <>
                                            <div className="col-md-6">
                                                <p className='genericlabel'>Resolution : {sellerData?.resolutions[0]?.descriptor?.code}</p>
                                                <p className='genericlabel'>Description : {sellerData?.resolutions[0]?.descriptor?.short_desc}</p>
                                                <p className='genericlabel'>Updated At : {sellerData?.resolutions[0]?.updated_at}</p>
                                                <div>
                                                    <label className='genericlabel' htmlFor="">Choose your action</label>
                                                    <select name="" id="" className='form-control' onChange={(e) => {
                                                        setresolutionObject((prev) => {
                                                            return { ...prev, actions_code: e.target.value }
                                                        })
                                                    }}>
                                                        <option value="" selected disabled>Select</option>
                                                        <option value="RESOLUTION_ACCEPTED">Accept resolution</option>
                                                        <option value="RESOLUTION_REJECTED">Reject resolution</option>
                                                        <option value="ESCALATED">Escalate</option>
                                                        <option value="CLOSED">Close</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </>
                                    }


                                    <div className="col-md-12 d-flex justify-content-end">

                                        {!id ? <button type="submit" className="btn btn-dark" onClick={createTicketHandler}>
                                            Create
                                        </button> : <button className='btn btn-success btn-sm' onClick={submitActionHandler} >Submit your action</button>}
                                    </div>
                                    {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </ThemeMaker>
        </>
    )
}
